
// COMPONENTS
import number from './ko-render-field-number/ko-render-field-number.js';
import list from './ko-render-field-list/ko-render-field-list.js';
import password from './ko-render-field-password/ko-render-field-password.js';
import text from './ko-render-field-text/ko-render-field-text.js';
import boolean from './ko-render-field-boolean/ko-render-field-boolean.js';
import json from './ko-render-field-json/ko-render-field-json.js';
import object from './ko-render-field-object/ko-render-field-object.js';
import multiselectList from './ko-render-field-multiselect-list/ko-render-field-multiselect-list.js';
import date from './ko-render-field-date/ko-render-field-date.js';
import time from './ko-render-field-time/ko-render-field-time.js';
import file from './ko-render-field-file/ko-render-field-file.js';
import address from './ko-render-field-address/ko-render-field-address.js';
import url from './ko-render-field-url/ko-render-field-url.js';
import phone from './ko-render-field-phone/ko-render-field-phone.js';
import email from './ko-render-field-email/ko-render-field-email.js';
import percentage from './ko-render-field-percentage/ko-render-field-percentage.js';

import render_field from './ko-render-field/ko-render-field.js';
import render_fields from './ko-render-fields/ko-render-fields.js';

export default [
	boolean,
	number,
	list,
	password,
	text,
	json,
	render_field,
	render_fields,
	object,
	multiselectList,
	date,
	time,
	file,
	address,
	url,
	phone,
	email,
	percentage
];
